import { ACCOUNT_TRACKING_EVENTS } from 'features/account/constants'
import getAccountTracking from 'features/account/helpers/getAccountTracking'

import actions from './actions'
import selectors from './selectors'

export const operationToggleClubCard = () => (dispatch, getState) => {
  const appState = getState()
  const { trackEvent } = getAccountTracking(appState)
  const trackShowMemberID = trackEvent(ACCOUNT_TRACKING_EVENTS.showMemberID.id)
  const isClubCardDrawerOpen = selectors.getIsClubCardDrawerOpen(appState)
  if (!isClubCardDrawerOpen) {
    trackShowMemberID()
  }

  dispatch(actions.toggleClubCardDrawer())
}

export default {
  operationToggleClubCard,
}
